import { Icon, IconProps } from '@elkaso-app/web-design';
import { HiChartBar } from 'react-icons/hi';

export const PocCallAnalysisIcon = (props: IconProps) => {
  return <Icon as={HiChartBar} width='24px' height='24px' viewBox='0 0 24 24' fill='#757575' {...props} />;
};
